import React, { useState } from 'react'
import Datatable3 from '../../table/datatable3'
import { InvestorInfo } from '../../../pages/distributorPage/InvestorInfo'

const EmployeeList = ({totalPage,currentPage,setCurrentPage,buttonOptions,employeeDetails,getAllEmployee }) => {

  const columns = [
    { id: 'name', header: ' Name' },
    { id: 'user_email', header: 'Email' },
    { id: 'mobile_number', header: 'Phone No' },
    // { id: 'scheme', header: 'Scheme' },
    // { id: 'class', header: 'Class' },
  ];


  return (
    <>
    
    <Datatable3 getAllEmployee={getAllEmployee} totalPage={totalPage} currentPage={currentPage} setCurrentPage={setCurrentPage} buttonOptions={buttonOptions} data={employeeDetails} columns={columns} user_type="employee" />
   
   
    </>
  )
}

export default EmployeeList